import { DropDownVariant, QPointSuggestlistComponent } from './../../../../projects/qpoint-forms/src/lib/suggestlist/suggestlist.component';
import { Component } from '@angular/core';
import { QPointButtonComponent } from '../../../../projects/qpoint-button/src/lib/button/button.component';
import { QPointToolbarComponent, QPointContentContainerComponent } from '@qpoint/layout';
import { PopupSettings } from '@progress/kendo-angular-dropdowns';
import { QPointSuggestlistDetailTemplateDirective } from './../../../../projects/qpoint-forms/src/lib/suggestlist/qpoint-suggestlist-detail-template.directive';
import { QPointSuggestlistNoDataTemplateDirective } from './../../../../projects/qpoint-forms/src/public_api';

export class GalleryListItem {
  code: string;
  description: string;
  number: number;
}

@Component({
    selector: 'app-control-gallery-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    imports: [
        QPointToolbarComponent,
        QPointContentContainerComponent,
        QPointButtonComponent,
        QPointSuggestlistComponent,
        QPointSuggestlistDetailTemplateDirective,
        QPointSuggestlistNoDataTemplateDirective
    ]
})
export class ControlGalleryDropdownComponent {
  public listItems: Array<GalleryListItem> = [
    { code: '00001', description: 'KendoChart', number: 1 },
    { code: '00002', description: 'KPI', number: 2 },
    { code: '00003', description: 'SsrsReport', number: 3 },
    { code: '00004', description: 'Map', number: 4 },
    { code: '00005', description: 'Grid', number: 5 },
    {
      code: '00006',
      description: 'LLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLBBBBBBBBBBBBBBBBBBBBBBBBFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA',
      number: 6
    }
  ];
  public isLoading: boolean;
  public DropdownVariant = DropDownVariant;
  public popupSettings: PopupSettings = {
    width: "auto"
  };

  public onDropDownListChange(value) {
    console.log('DropDownList - change = ', value);
  }

  public onComboBoxChange(value) {
    console.log('ComboBoxList - change = ', value);
  }

  public onMultiSelectChange(value) {
    console.log('MultiSelect - change = ', value);
  }
}
